
import { defineComponent, PropType } from 'vue'
import { iOlapFilter, iOlap } from '@/modules/documentExecution/olap/Olap'
import panelDescriptor from './OlapFilterPanelDescriptor.json'
import InlineMessage from 'primevue/inlinemessage'
import FilterCard from './OlapFilterCard.vue'

export default defineComponent({
    components: { InlineMessage, FilterCard },
    props: { olapProp: { type: Object as PropType<iOlap | null>, required: true }, olapDesigner: { type: Object } },
    emits: ['putFilterOnAxis', 'showMultiHierarchy', 'openFilterDialog'],
    computed: {
        showScroll(): Boolean {
            return this.scrollContainerWidth < this.scrollContentWidth
        }
    },
    data() {
        return {
            panelDescriptor,
            filterCardList: [] as iOlapFilter[],
            scrollContainerWidth: 0,
            scrollContentWidth: 0
        }
    },
    watch: {
        olapProp() {
            this.loadData()
        }
    },
    created() {
        this.loadData()
    },

    methods: {
        loadData() {
            this.filterCardList = this.olapProp?.filters as iOlapFilter[]
            window.addEventListener('resize', this.assignScrollValues)
            this.assignScrollValues()
        },
        displayDropzone() {
            // @ts-ignore
            this.$refs.axisDropzone.classList.add('display-axis-dropzone')
        },
        hideDropzone() {
            // @ts-ignore
            this.$refs.axisDropzone.classList.remove('display-axis-dropzone')
        },
        onDrop(event) {
            // @ts-ignore
            this.$refs.axisDropzone.classList.remove('display-axis-dropzone')
            var data = JSON.parse(event.dataTransfer.getData('text/plain'))
            var topLength = this.olapProp?.columns.length
            var leftLength = this.olapProp?.rows.length
            var fromAxis
            if (data != null) {
                fromAxis = data.axis
                if (data.measure) {
                    this.$store.commit('setInfo', { title: this.$t('common.toast.warning'), msg: this.$t('documentExecution.olap.filterToolbar.noMeasure') })
                    return null
                }
                if (fromAxis != -1) {
                    if ((fromAxis === 0 && topLength == 1) || (fromAxis === 1 && leftLength == 1)) {
                        this.$store.commit('setInfo', { title: this.$t('common.toast.warning'), msg: this.$t('documentExecution.olap.filterToolbar.dragEmptyWarning') })
                    } else {
                        data.positionInAxis = this.filterCardList.length
                        data.axis = -1
                        this.$emit('putFilterOnAxis', fromAxis, data)
                    }
                }
            }
            setTimeout(() => {
                this.assignScrollValues()
            }, 100)
        },
        emitMultiHierarchy(filter) {
            this.$emit('showMultiHierarchy', filter)
        },
        scrollLeft() {
            // @ts-ignore
            this.$refs.filterItemsContainer.scrollLeft -= 50
        },
        scrollRight() {
            // @ts-ignore
            this.$refs.filterItemsContainer.scrollLeft += 50
        },
        assignScrollValues() {
            // @ts-ignore
            this.scrollContainerWidth = this.$refs?.filterPanelContainer?.clientWidth
            // @ts-ignore
            this.scrollContentWidth = this.$refs?.filterItemsContainer?.scrollWidth
        }
    }
})
